export default "__VITE_ASSET__CRUpJx2d__"